import { useMemo } from 'react';
import createMessagePreview from 'App/utils/createMessagePreview';
import useCompanySetting from 'App/hooks/useCompanySetting';

const DEFAULT_MAX_COUNT = 320;

function useCreateMesssagePreview(message = '', requestCallback = false) {
    const { isLoading: isLoadingBranchName, data: branchNameData } = useCompanySetting('messagingBranchName', {
        defaultValue: '',
    });

    const { isLoading: isLoadingPhoneNumber, data: phoneNumberData } = useCompanySetting('messagingPhone', {
        defaultValue: '',
    });

    const isLoadingCompanySettings = isLoadingBranchName || isLoadingPhoneNumber;

    const [branchName = '', phoneNumber = ''] = useMemo(() => {
        if (!isLoadingCompanySettings) {
            return [branchNameData || '', phoneNumberData || ''];
        }
        return [];
    }, [branchNameData, isLoadingCompanySettings, phoneNumberData]);

    const preview = useMemo(() => {
        const result = createMessagePreview(branchName, message, phoneNumber, requestCallback);
        const bodyWithoutBranch = message.trim();
        let footerWithoutPhone = requestCallback ? 'Please call the pharmacy' : 'Questions? Call';
        footerWithoutPhone += '. Unmonitored number. Text END to opt out.';
        /**
         * We need to display  the max count correctly based on the required message pieces. Otherwise, the user will wonder
         * Why they can't enter X number of characters. This subtracts those values that are always required here and sets
         * the max value to be used in all the places. When branch and phone are included, there are often 3 additional
         * characters added to the output: a colon (:) and two additional spaces.
         */
        result.maxCount = DEFAULT_MAX_COUNT - [branchName, ':  ', result.footer].join('').length;
        result.completeMessage = `${result.body} ${result.footer}`;
        result.messageWithoutBranchPhone = `${bodyWithoutBranch} ${footerWithoutPhone}`;
        return result;
    }, [branchName, message, phoneNumber, requestCallback]);
    return {
        ...preview,
        isLoading: isLoadingCompanySettings,
    };
}

export default useCreateMesssagePreview;
